import { TypographyWithEllipsis } from '@modules/common/components/TypographyWithEllipsis';
import { Stack } from '@mui/material';
import { ReactElement } from 'react';

interface BarChartYAxisLabelProps {
  label: string | number | ReactElement;
}

export const BarChartYAxisLabel = ({ label }: BarChartYAxisLabelProps) => {
  return (
    <Stack
      data-role="bar-chart-y-axis-label"
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        maxHeight: '250px',
      }}
    >
      <TypographyWithEllipsis
        variant="subtitle1"
        color="text.primary"
        textAlign="center"
        sx={{
          transform: 'rotate(180deg)',
          writingMode: 'vertical-lr',
          height: '100%',
        }}
        tooltipProps={{
          arrow: true,
          placement: 'top',
        }}
      >
        {label}
      </TypographyWithEllipsis>
    </Stack>
  );
};
